<template>
  <div class='top-card-wrap'>
    <div class='container a-white a-text-12' :class='levelClass'>
      <div class='validity' v-if='privleft'>{{privleft}}</div>
      <div class='status fx-center' :style="{color: btnText == '立即购买' ? '#745323':'#ffffff'}">{{btnText}}</div>
    </div>
  </div>
</template>

<script>


export default {
  props: {
    level: {
      type: [String, Number],
      required: true
    },
    privleft: {
      type: String,
      default: ''
    },
    currentIndex: {
      type: [String, Number],
      required: true
    },
    levelClass: {
      type: String,
      default: 'normal'
    }
  },
  computed: {
    btnText() {
      let _i = Number(this.level);
      let _j = Number(this.currentIndex);
      if ( _j < _i) {
        return '已解锁';
      } else if (  _j == _i ) {
        return '当前等级';
      } else if ( _j > _i && (_j!==1 || _j!==2)) {
        return '立即购买';
      } else {
        return '待解锁';
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/scss/_vars.scss";

$type: platinum, silver, gold, diamond;

.top-card-wrap {
  padding-top: 8 * $px;
  background: #ffffff;
  .container {
    width: 325 * $px;
    height: 176 * $px;
    background: url('https://cdn.133.cn/gtgj/vipcard/normal.png') no-repeat center top;
    background-size: 100%;
    position: relative;
    margin: 0 auto;

    @each $name in $type {
      &.#{$name} {
        background-image: url('https://cdn.133.cn/gtgj/vipcard/#{$name}.png');
      }
    }

    .validity {
      position: absolute;
      top: 58 * $px;
      left: 97 * $px;
      opacity: 0.8;
    }
    .status {
      width: 85 * $px;
      height: 26 * $px;
      position: absolute;
      left: 24 * $px;
      top: 95 * $px;
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/projects/vipCard/pages/home/components/home-top-card.vue